// Firebase Web SDK bootstrap for ApexMotorGarage / PartsGrid.
//
// The client-side apiKey / projectId etc. are NOT secrets — they identify the
// project so Firebase can route requests. Real security is enforced by the
// Firebase Console rules + backend Admin-SDK verification of the ID token
// returned by phone-auth.
//
// We lazy-init because analytics + auth pull code we don't need on every page.

import { initializeApp, getApps } from "firebase/app";
// Import under a non-`use*` alias so eslint-plugin-react-hooks doesn't confuse
// Firebase's `useDeviceLanguage` utility with a React hook.
import { getAuth, useDeviceLanguage as setDeviceLanguage } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCjDjYppZ46p3489t6GqVNpJH0bHVZOtd0",
  authDomain: "apexmotorgarage-76233.firebaseapp.com",
  projectId: "apexmotorgarage-76233",
  storageBucket: "apexmotorgarage-76233.firebasestorage.app",
  messagingSenderId: "574324050604",
  appId: "1:574324050604:web:733b9c26a4b210eb332d09",
  measurementId: "G-BQCWL796QK",
};

let _app = null;
export function getFirebase() {
  if (_app) return _app;
  _app = getApps()[0] || initializeApp(firebaseConfig);
  return _app;
}

let _auth = null;
export function getFirebaseAuth() {
  if (_auth) return _auth;
  _auth = getAuth(getFirebase());
  // Match the browser's language so SMS OTP arrives in the user's locale
  try { setDeviceLanguage(_auth); } catch { /* non-fatal */ }
  return _auth;
}
